import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { Protected, AdminOnly } from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Transaksi from '@/pages/Transaksi';
import Stok from '@/pages/Stok';
import Opname from '@/pages/Opname';
import OperStok from '@/pages/OperStok';
import Pengeluaran from '@/pages/Pengeluaran';
import Riwayat from '@/pages/Riwayat';
import Laporan from '@/pages/Laporan';
import Pengguna from '@/pages/Pengguna';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/transaksi" element={<Transaksi />} />
            <Route path="/stok" element={<Stok />} />
            <Route path="/opname" element={<Opname />} />
            <Route path="/oper-stok" element={<OperStok />} />
            <Route path="/pengeluaran" element={<Pengeluaran />} />
            <Route path="/riwayat" element={<Riwayat />} />
            <Route path="/laporan" element={<AdminOnly><Laporan /></AdminOnly>} />
            <Route path="/pengguna" element={<AdminOnly><Pengguna /></AdminOnly>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors toastOptions={{
        style: { background: 'var(--elevated)', border: '1px solid var(--line)', color: 'var(--foreground, #F4F5F7)' },
      }} />
    </AuthProvider>
  );
}

export default App;
